module.exports = __webpack_public_path__ + "static/media/male_left_grey.95147f4a.png";